export class ApiError extends Error {
  constructor(message: string, status: number) {
    super(`${message} - (${status})`);
  }
}
